import { swaDate } from "../swaDate";

export const removeTimeZone = (str: string): string => {
  const offset = swaDate.parseZone(str).utcOffset() * 60 * 1000;

  return swaDate.utc(swaDate.utc(str).valueOf() + offset).format("YYYY-MM-DDTHH:mm:ss");
};
